export default "fdafcfa39e139a52.svg"